import { PropertyBindingType } from '@angular/compiler';

export class Oferta {
  RetrieveCustomerOfferProcedureResponse: RetrieveCustomerOfferProcedureResponse = new RetrieveCustomerOfferProcedureResponse();
  OfferSearchDate: string;
}


export class RetrieveCustomerOfferProcedureResponse {
  Offers: Array<Offers> = [];
}


// #region RequestGetOffers
export class RequestOffers {
  RetrieveCustomerOfferProcedure: RetrieveCustomerOfferProcedure = new RetrieveCustomerOfferProcedure();
}

class RetrieveCustomerOfferProcedure {
  Customer: CustomerRequest = new CustomerRequest();
  CommunicationChannel: CommunicationChannel = new CommunicationChannel();
}

class CustomerRequest {
  RepresentativeOfCustomer: RepresentativeOfCustomerRequest = new RepresentativeOfCustomerRequest();
}


class RepresentativeOfCustomerRequest {
  Person: PersonRequest = new PersonRequest();
}


class PersonRequest {
  PersonIdentification: PersonIdentificationRequest = new PersonIdentificationRequest();
}


class PersonIdentificationRequest {
  TypeOfIdentification: string;
  IdentityCardNumber: string;
}




class CommunicationChannel {
  Type: string;
  ExposedPointOfInteraction: ExposedPointOfInteraction = new ExposedPointOfInteraction();
}

class ExposedPointOfInteraction {
  GroupIdentifier: string;
}



// #endregion


export class Offers {
  CustomerOffer: CustomerOffer = new CustomerOffer();
  Customer: Customer = new Customer();
  LoanAgreement: LoanAgreement = new LoanAgreement();
  PaymentCard: PaymentCard = new PaymentCard();
  CashAccount: CashAccount = new CashAccount();
  PhoneAddress: Array<PhoneAddress> = [];
  OrganisationReference: OrganisationReference = new OrganisationReference();
  AditionalInformationList: AditionalInformationList = new AditionalInformationList();
  Show: String;
}

class CustomerOffer {
  CustomerOfferReference: string;
  OfferedAgreement: OfferedAgreement = new OfferedAgreement();
  Status: number;
  ValidityPeriod: ValidityPeriod = new ValidityPeriod();
  Audit: Audit = new Audit();
}

// #region CustomerOffer
class OfferedAgreement {
  Product: Product = new Product();
  Jurisdiction: Jurisdiction = new Jurisdiction();
  Account: Array<Account> = [];
  Comment: Array<string> = [];

}
// #endregion

// #region OfferedAgreement:Product
class Product {
  ProductIdentification: ProductIdentification = new ProductIdentification();
  Name: string;
  Characteristics: Characteristics = new Characteristics();
  Adjustment: Adjustment = new Adjustment();
  ProductCategory: ProductCategory = new ProductCategory();
}

class ProductIdentification {
    Identifier: string;
}

class Characteristics {
    Type: string;
}

class Adjustment {
    SecuritiesOrder: SecuritiesOrder;
}

class SecuritiesOrder {
    Identification: string; //null
}

class ProductCategory {
    Category: string; //null
}
// #endregion

// #region OfferedAgreement:Jurisdiction
class Jurisdiction {
  RegisteredSecurity: RegisteredSecurity = new RegisteredSecurity();
  SecuritiesRestriction: SecuritiesRestriction = new SecuritiesRestriction();
}
class RegisteredSecurity {
  Identification: Identification = new Identification();
}

class Identification {
  SecurityIdentification: string;
}

class SecuritiesRestriction {
  RestrictionType: string;
}
// #endregion

// #region OfferedAgreement:Account

class Account {
  AccountService: AccountService = new AccountService();
  BaseCurrency: string;
  Identification: AccountIdentification = new AccountIdentification();
  ManagedAccountProduct: ManagedAccountProduct = new ManagedAccountProduct()
}

class AccountService {
  AccountAdministrationCharge: AccountAdministrationCharge = new AccountAdministrationCharge();
}

class AccountAdministrationCharge {
    RelatedInterest: any;
}

class RelatedInterest {
    Rate: string;
    InterestType: string;
    RateType: string;
}

class AccountIdentification {
  Number: string; //null
  Name: string;
}

class ManagedAccountProduct {
  Adjustment: Adjustment = new Adjustment();
}




// #endregion

// #region ValidityPeriod

class ValidityPeriod {
  FromDateTime: string;
  ToDateTime: string;
}

// #endregion

// #region Audit

class Audit {
  GuidelineComplianceCheck: GuidelineComplianceCheck = new GuidelineComplianceCheck();
}


class GuidelineComplianceCheck {
  CheckedGuideline: Array<CheckedGuideline> = [];
}

class CheckedGuideline {
  Type: string;
  Description: string;
}


// #endregion

// #region Customer

class Customer {
  RepresentativeOfCustomer: RepresentativeOfCustomer = new RepresentativeOfCustomer();
  Agreement: AgreementCustomer = new AgreementCustomer();
  PartyRole: string;
  RelationshipManager: RelationshipManager = new RelationshipManager();
  CustomerReference: string; //null
  Location: Location = new Location();
  ContactPersonRole: ContactPersonRole = new ContactPersonRole();
  PresentationForCustomer: PresentationForCustomer = new PresentationForCustomer();
}

class RepresentativeOfCustomer {
  Person: Person = new Person();
  Role: Role = new Role();
}

class Person {
  PersonIdentification: PersonIdentification = new PersonIdentification();
}

class PersonIdentification {
  TypeOfIdentification: string;
  IdentityCardNumber: string;
  PersonName: PersonName;
}

class PersonName {
  LastName: string;
  SecondLastName: string;
  GivenName: string;
  MiddleName: string; //null
}

class Role {
  Agreement: Agreement = new Agreement();
}

class Agreement {
  DateSigned: string;
}
// #endregion

// #region Customer:AgreementCustomer

class AgreementCustomer {
  Account: AccountCustomer = new AccountCustomer();
  Product: ProductCustomer;
}

class AccountCustomer {
  Identification: IdentificationCustomer = new IdentificationCustomer();  
  Status: Status = new Status();
  ManagedAccountProduct: ManagedAccountProductAccount = new ManagedAccountProductAccount();
}

class IdentificationCustomer {
  BBAN: string;
}

class Status {
  CancellationProcessingStatus: string; //null
  StatusReason: StatusReason = new StatusReason();
}

class StatusReason {
  CancellationReason: string; //null
}

class ManagedAccountProductAccount {
  ProductIdentification: ProductIdentificationAccount = new ProductIdentificationAccount();
}

class ProductIdentificationAccount {
  Identifier: string; //null
}

class ProductCustomer {
  ProductIdentification: ProductIdentificationAccount = new ProductIdentificationAccount();
  Characteristics: Characteristics = new Characteristics();
}

class RelationshipManager {
  Organisation: Organisation = new Organisation();
}

class Organisation {
  OrganisationIdentification: OrganisationIdentification = new OrganisationIdentification();
}

class OrganisationIdentification {
  OrganisationName: OrganisationName = new OrganisationName();
}

class OrganisationName {
  LegalName: string;
}

class Location {
  Address: Address = new Address();
  FullAddress: string; //null
}

class Address {
  DistrictName: string //null
}

class ContactPersonRole {
  Person: PersonRole = new PersonRole();
}

class PersonRole {
  PersonProfile: PersonProfile = new PersonProfile();
  PersonIdentification: PersonIdentificationRole = new PersonIdentificationRole();
  CreditRating: string; //null
}

class PersonProfile {
  CustomerConductClassification: string; //null
}

class PersonIdentificationRole {
  PartyType: string; //null
}

class PresentationForCustomer {
  ElectronicPresentationAddress: ElectronicPresentationAddress = new ElectronicPresentationAddress();
  CommunicationMethod: string; //null
}

class ElectronicPresentationAddress {
  EmailAddress: string; //null
}







// #endregion

// #region LoanAgreement
class LoanAgreement {
  LoanProduct: Array<LoanProduct> = [];
}

class LoanProduct {
  Loan: Loan;
}

class Loan {
  Limit: Limit;
  WeightedAverageLife: string;
  WeightedAverageLoan: string;
  InterestPaymentsSchedule: InterestPaymentsSchedule = new InterestPaymentsSchedule();
}

class Limit {
  Amount: number;
  Type: string;
  AvailableAmount: number;
}

class InterestPaymentsSchedule {
  Amount: number;
  Type: string; //null
}

// #endregion

// #region PaymentCard

class PaymentCard {
  ProfileNumber: string;
  Type: string;
  Number: string; //null
  CardBrand: string; //null
}

// #endregion

// #region CashAccount

class CashAccount {
  CashBalance: CashBalance;
  ManagedAccountProduct: ManagedAccountProductCashAccount = new ManagedAccountProductCashAccount();
}

class CashBalance {
  Availability: Availability = new Availability();
}

class Availability {
  Amount: string;
}

class ManagedAccountProductCashAccount {
  ProductIdentification: ProductIdentification = new ProductIdentification();
}



// #endregion

// #region PhoneAddress

class PhoneAddress {
  PhoneNumber: string;
  Description: string;
}

// #endregion

// #region OrganisationReference

class OrganisationReference {
  Location: LocationReference = new LocationReference();
}

class LocationReference {
  FullAddress: string; //null
}

// #endregion

// #region AditionalInformationList

class AditionalInformationList {
  AditionalInformation: Array<Wildcard>;
}

class Wildcard {
  Key: string;
  Value: string;
}

// #endregion

interface Dictionary<T> {
   [K: string]: T;
}




















